import { useEffect, useRef, useState } from 'react'
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import ImageUpload from './ImageUpload';
import { addNewAnnouncements, updateAnnouncements } from '../../../../../../actions/appsMoreAction';
import { SOCKET_CONNECTION, TOAST_ERROR, TOAST_SUCCESS } from '../../../../../../utils';
import { closePricingModal } from '../../../../../../utils/close_modal';
import { refreshThemes } from '../../../../../../actions/firstRunAction';
import { useDispatch } from 'react-redux';
import DateTimeField from '@1stquad/react-bootstrap-datetimepicker';
import '@1stquad/react-bootstrap-datetimepicker/css/bootstrap-datetimepicker.css'
import { UPPY_BUCKET_URL } from '../../../../../../actions/constant';
import { FontAwesomeIcon } from '../../../../../CommonComponents/AssetsHelper';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';


function AddAnnouncements({ onHide, announcementsListData, announcementsStatus, itemIndex, details }) {
    const [announcementsDurationSelect, setAnnouncementsDurationSelect] = useState([{ value: 1, label: `1 Min` }, { value: 3, label: `3 Mins` }, { value: 5, label: `5 Mins` }, { value: 10, label: `10 Mins` }, { value: 30, label: `30 Mins` }, { value: '0', label: `Once` }])
    const [announcementsDuration, setAnnouncementsDuration] = useState(announcementsStatus === 2 ? announcementsListData[itemIndex].every : 1)
    const [discription, setDiscription] = useState(announcementsStatus === 2 ? announcementsListData[itemIndex].description : '');
    const [startAt, setStartAt] = useState(announcementsStatus === 2 ? announcementsListData[itemIndex].showAt : "")
    const [endAt, setEndAt] = useState(announcementsStatus === 2 ? announcementsListData[itemIndex].endAt : "")
    const [endAtStatus, setEndAtStatus] = useState(0)

    
    const [defaultStart, setdefaultStart] = useState();
    const [defaultEnd, setdefaultEnd] = useState();
    const [mediaFilePath, setmediaFilePath] = useState();
    const [videoType, setvideoType] = useState(0);
    const [postImage, setpostImage] = useState(announcementsStatus === 2 ? announcementsListData[itemIndex].mediaFile : '');
    const [mediaSize, setmediaSize] = useState([]);
    const [mediaWidth, setmediaWidth] = useState(0);
    const [mediaHeight, setmediaHeight] = useState(0);
    const [thumbFile, sethumbFile] = useState('');
    const [postType, setpostType] = useState(0);
    const [mediaType, setmediaType] = useState(null);
    const [discriptionError, setDiscriptionError] = useState(false);
    const [startAtError, setStartAtError] = useState(false);
    const [isSpinner, setIsSpinner] = useState(false);
    const dispatch = useDispatch();

    const onPostUpload = (url) => {
        if (mediaType == 'image') {
            setpostImage(`${UPPY_BUCKET_URL}media/tmpimages/${url}`);
        }
    }
    const myRefStartAt = useRef(null)
    const myRefEndAt = useRef(null)
    useEffect(() => {
        if (announcementsStatus === 2) {
            setEndAt(announcementsListData[itemIndex].endAt)
            setdefaultStart(announcementsListData[itemIndex].showAt);
            setdefaultEnd(announcementsListData[itemIndex].endAt);
            setStartAt(announcementsListData[itemIndex].showAt)
            setEndAtStatus(announcementsListData[itemIndex].endAt ? 1 : 0)
        }
    }, [])

    const onSubmitData = () => {
 
       if(!discription) {
        setDiscriptionError(true)
        return;
       }
       // TOAST_LOADING()
        if (!myRefStartAt.current.state.inputValue) {
            if (!myRefStartAt.current.state.inputValue)  setStartAtError(true)
            setIsSpinner(false)
            return false
        }
       setIsSpinner(true);

        let startTime = moment(myRefStartAt.current.state.inputValue.replace('T', ' ').replace('.000Z', '')).valueOf()
        let endTime = moment(myRefEndAt.current.state.inputValue.replace('T', ' ').replace('.000Z', '')).valueOf()

        let data = { wallId: details.wallId, description: discription, showAt: startTime, every: announcementsDuration, mediaFile: postImage, mediaFileRemove: postImage ? 0 : 1, endAt: endAtStatus ? endTime : '' }
        if (data && startTime) {
            if (announcementsStatus !== 2) {
                addNewAnnouncements(data).then((res) => {
                    const { responseCode, responseData, syncId} = res.data
                    if (responseCode == 200) {
                        TOAST_SUCCESS("Announcement added successfully.")
                        if(syncId) SOCKET_CONNECTION.emit('wallsuperrefresh', { 'wallId': details.wallId, sync: syncId });
                        closePricingModal(dispatch);
                        dispatch(refreshThemes());
                        onHide()
                    }

                }).catch(res => {
                    TOAST_ERROR(res.message)
                    onHide()
                })
            } else {
                let id = announcementsListData[itemIndex].id;
        
                if(announcementsListData[itemIndex].mediaFile != "" && announcementsListData[itemIndex].mediaFile == postImage){
                    data = {...data, mediaFile: postImage};
                }
                updateAnnouncements(id, data).then((res) => {
                    const { responseCode, responseData , syncId} = res.data
                    if (responseCode == 200) {
                        TOAST_SUCCESS("Announcement update successfully.");
                        if(syncId) SOCKET_CONNECTION.emit('wallsuperrefresh', { 'wallId': details.wallId, sync: syncId });
                        closePricingModal(dispatch);
                        dispatch(refreshThemes());
                        onHide()
                    }

                 }).catch(res => {
                    TOAST_ERROR(res.message)
                    onHide()
                })
            }
        }
        setIsSpinner(false)
    }

    const handleChange = (e) => {
        setStartAtError(false)
    }

    return (
        <div className='maintainPopUp'>
            <div className='modal-body'>
                <div className="row">
                    <div className="col-md-5">
                        <input type="hidden" className="form-control" defaultValue={''} />
                        <ImageUpload
                            setmediaFilePath={setmediaFilePath} setvideoType={setvideoType} setpostImage={setpostImage} setmediaSize={setmediaSize} setmediaWidth={setmediaWidth} setmediaHeight={setmediaHeight} sethumbFile={sethumbFile} postType={postType} onImgUpload={onPostUpload} mediaTypeFile={mediaType} setmediaType={setmediaType} onRemovePost={setpostImage} imageName={postImage}
                        />
                    </div>
                    <div className="col-md-7">
                        <div className="form-group after">
                            <label>Content</label>
                            <textarea className='form-control' rows={3} cols={5} value={discription} onChange={(e) => {
                                setDiscriptionError(false)
                                setDiscription(e.target.value)
                            }} />
                            {discriptionError ? <span className="errorMessage required">This field is required.</span> : null}
                        </div>
                        <div className="row">
                            <div className="col-sm-8">
                                <div className="form-group">
                                    <label>Start At</label>
                                    <div className="input-group" data-target-input="nearest">

                                        <DateTimeField
                                            language={'en'}
                                            open={true}
                                            key={defaultStart}
                                            minDate={new Date()}
                                            dateTime={moment(defaultStart || new Date()).local().format("DD MMM YYYY h:mm A")} 
                                            inputFormat={'YYYY-MM-DD HH:mm'}
                                            onChange={(e) => handleChange(e)}
                                            viewMode={'date'}
                                            closeOnClickOutside={false}
                                            closeOnTab={false}
                                            className="form-control"
                                            startOfWeek={'week'}
                                            ref={myRefStartAt}
                                            direction="top"
                                            widgetStyle={{ left: '0' }}
                                        />
                                        <div onClick={(e) => myRefStartAt.current.onClick()} className="input-group-append" >
                                            <span className="input-group-text">
                                                <i className="fa fa-calendar-days"></i>
                                            </span>
                                        </div>
                                    </div>
                                    {startAtError ? <span className="errorMessage required">This field is required.</span> : null}
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="form-group">
                                    <div className="input-group recurrenceSec">
                                        <label>Every</label>
                                        <div className="input-group select-box">
                                            {announcementsDurationSelect && announcementsDurationSelect.length ? <Select options={announcementsDurationSelect} value={announcementsDurationSelect[announcementsDurationSelect.findIndex(i => i.value == announcementsDuration)]} onChange={(e) => setAnnouncementsDuration(e.value)} ></Select> : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="checkbox-inline">
                                <label className="form-check p-0">
                                    <input type='checkbox' className='form-check-input me-2' value={endAtStatus} checked={endAtStatus} onChange={() => {
                                        setEndAtStatus(!endAtStatus ? 1 : 0);
                                    }} />
                                    End At
                                </label>
                            </div>
                            <span  className="errorMessage"> </span>
                            <div className="input-group init endAt" data-target-input="nearest" style={{ display: endAtStatus ? '' : 'none' }}>

                                    <DateTimeField
                                        language={'en'}
                                        key={defaultEnd}
                                        open={true}
                                        minDate={new Date()}
                                        dateTime={moment(defaultEnd || new Date()).local().format("DD MMM YYYY h:mm A")} 
                                        inputFormat={'YYYY-MM-DD HH:mm'}
                                        viewMode={'date'}
                                        closeOnClickOutside={false}
                                        closeOnTab={false}
                                        className="form-control"
                                        startOfWeek={'week'}
                                        ref={myRefEndAt}
                                        direction="top"
                                        widgetStyle={{ left: '0',}}
                                    />

                                <div onClick={(e) => { myRefEndAt.current.onClick() }} className="input-group-append" data-target="#postcAt" data-toggle="datetimepicker">
                                    <span className="input-group-text">
                                        <FontAwesomeIcon type={'regular'} icon={'calendar-days'} iconClass={'fs-6 text-dark'} />
                                    </span>
                                </div>
                            </div>
                            <span style={{ display: 'none' }} className="fgroupEndAtHide errorMessage required">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <div className="d-flex align-items-center justify-content-end w-100">
                    <div className="card-toolbar">
                        <Button variant='secondary' className="me-2" onClick={onHide} >Close</Button>
                        <Button variant='primary' className={`addMoreAnnocBtn ${isSpinner ? 'spinner spinner-white spinner-right disabled' : null}`} onClick={() => onSubmitData()}>{announcementsStatus !== 2 ? `Add Announcements` : `Update Announcements`}</Button>
                        <a href="https://vimeo.com/548771928/c02902a821" className="ms-2 lity_lightbox" data-lity="" data-factors-click-bind="true">
                            <span data-bs-placement="right" data-bs-toggle="tooltip" title="How to Add Announcements on your Social Wall?">
                                <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={'fs-5 text-secondary'} />
                            </span>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default AddAnnouncements

